const state = {
  list: [],
  record: {
    address: {},
    timeline: []
  }
}

export default state
